// 👉 Normalise pour recherche sans accents ni casse
export function normalizeString(str = "") {
  return str
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
}